import { configureStore } from "@reduxjs/toolkit";
import productsReducer from "./slices/productsSlice";
import categoriesReducer from "./slices/categoriesSlice";
import brandsReducer from "./slices/brandsSlice";
import cartReducer from "./slices/cartSlice";
// import authReducer from "./slices/cognitoAuthSlice";
import authReducer from "./slices/authSlice";
import uiSlice from "./slices/uiSlice";
import enquiryReducer from "./slices/enquiryFormSlice";
import userReducer from "./slices/userSlice";
import catalogueReducer from "./slices/catalogSlice";
import mockupReducer from "./slices/mockupSlice";
import logoReducer from "./slices/logosSlice";
import authModalReducer from "./slices/authModalSlice";
import videoModalReducer from "./slices/videoModalSlice";
import aiModalReducer from "./slices/aiModalSlice";
import productDetailsReducer from "./slices/productDetailsSlice";
import aiChatReducer from "./slices/aiChatSlice";
import globalDialog from "./slices/globalDialogSlice";
import configurationReducer from "./slices/configurationSlice";
import eventsReducer from "./slices/eventsSlice";
import kitsReducer from "./slices/kitsSlice";


export const store = configureStore({
  reducer: {
    products: productsReducer,
    productDetails: productDetailsReducer,
    categories: categoriesReducer,
    brands: brandsReducer,
    cart: cartReducer,
    auth: authReducer,
    ui: uiSlice,
    enquiry: enquiryReducer,
    user: userReducer,
    catalog: catalogueReducer,
    mockup: mockupReducer,
    logo: logoReducer,
    aiChat: aiChatReducer,
    authModal: authModalReducer,
    videoModal: videoModalReducer,
    aiModal: aiModalReducer,
    globalDialog: globalDialog,
    configuration: configurationReducer,
    events: eventsReducer,
    kits: kitsReducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
        ignoredPaths: ["products.data", "categories.data", "brands.data"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
